export type Amenity = {
	code: string;
	name: string;
	icon: string;
	order: number;
	importance: number;
	type: string[];
	category?: string;
	data?: { code: string; name: string }[];
};

export const amenitiesInfo: Amenity[] = [
	{
		code: "amphiTheatre",
		name: "Amphi Theatre",
		icon: "amenities/colored/amphi-theatre",
		order: 1,
		importance: 0,
		type: ["entertainment"],
		category: "openCommonSpots",
	},
	{ code: "atm", name: "ATM", icon: "amenities/colored/atm", order: 2, importance: 0, type: ["lifestyle"] },
	{
		code: "auditorium",
		name: "Auditorium",
		icon: "amenities/colored/auditorium",
		order: 3,
		importance: 0,
		type: ["entertainment"],
		category: "openCommonSpots",
	},
	{
		code: "badmintonCourt",
		name: "Badminton Court",
		icon: "amenities/colored/badminton-court",
		order: 1,
		importance: 1,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "basketballCourt",
		name: "Basketball Court",
		icon: "amenities/colored/basketball-court",
		order: 1,
		importance: 1,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "café",
		name: "Café",
		icon: "amenities/colored/cafe",
		order: 2,
		importance: 0,
		type: ["lifestyle"],
		category: "openCommonSpots",
	},
	{
		code: "cardsRoom",
		name: "Cards room",
		icon: "amenities/colored/cards-room",
		order: 3,
		importance: 1,
		type: ["games"],
	},
	{
		code: "carromRoom",
		name: "Carrom room",
		icon: "amenities/colored/carrom-room",
		order: 3,
		importance: 1,
		type: ["games"],
	},
	{ code: "cctv", name: "CCTV", icon: "amenities/colored/cctv", order: 9, importance: 4, type: ["basic"] },
	{
		code: "crechePlayGroups",
		name: "Creche /play groups",
		icon: "amenities/colored/creche-play-groups",
		order: 1,
		importance: 0,
		type: ["kids", "lifestyle"],
		category: "kidsArea",
	},
	{
		code: "gaspipes",
		name: "Gas Pipes",
		icon: "amenities/colored/gas-pipes",
		order: 5,
		importance: 1,
		type: ["lifestyle"],
	},
	{
		code: "gym",
		name: "Gym",
		icon: "amenities/colored/gym",
		order: 1,
		importance: 1,
		type: ["lifestyle", "health"],
		category: "clubHallGym",
	},
	{
		code: "intercom",
		name: "Intercom",
		icon: "amenities/colored/intercom",
		order: 8,
		importance: 0,
		type: ["sports", "health"],
	},
	{
		code: "kidsPlayArea",
		name: "Kids Play Area",
		icon: "amenities/colored/kids-play-area",
		order: 2,
		importance: 4,
		type: ["kids"],
		category: "kidsArea",
	},
	{
		code: "library",
		name: "Library",
		icon: "amenities/colored/library",
		order: 1,
		importance: 2,
		type: ["kids", "entertainment", "lifestyle"],
	},
	{
		code: "lift",
		name: "Lift",
		icon: "amenities/colored/lift",
		data: [
			{ code: "manual", name: "Manual" },
			{ code: "automatic", name: "Automatic" },
		],
		order: 9,
		importance: 5,
		type: ["basic"],
	},
	{
		code: "maintenanceStaff",
		name: "Maintenance staff",
		icon: "amenities/colored/maintenance-staff",
		order: 9,
		importance: 4,
		type: ["lifestyle"],
	}, // icon-bellboy
	{
		code: "openGreenSpace",
		name: "Open/Green space",
		icon: "amenities/colored/open-green-space",
		order: 3,
		importance: 2,
		type: ["lifestyle", "eco"],
		category: "openCommonSpots",
	}, //	 icon-sun-bath
	{
		code: "poolTable",
		name: "Pool Table",
		icon: "amenities/colored/pool-table",
		order: 2,
		importance: 1,
		type: ["games"],
	},
	{
		code: "powerBackup",
		name: "Power Backup",
		icon: "amenities/colored/power-backup",
		data: [
			{ code: "full", name: "Full - 100%" },
			{ code: "commonAreas", name: "Common Areas" },
			{ code: "lift", name: "Lift" },
		],
		order: 8,
		importance: 5,
		type: ["basic"],
	},
	{
		code: "rainWaterHarvesting",
		name: "Rain water harvesting",
		icon: "amenities/colored/rain-water-harvesting",
		order: 3,
		importance: 0,
		type: ["eco"],
	},
	{ code: "security", name: "Security", icon: "amenities/colored/security", order: 7, importance: 4, type: ["basic"] },
	{
		code: "sewageTreatmentPlant",
		name: "Sewage Treatment Plant",
		icon: "amenities/colored/sewage-treatment-plant",
		order: 4,
		importance: 1,
		type: ["eco"],
	},
	{
		code: "shops",
		name: "Shops",
		icon: "amenities/colored/shops",
		order: 2,
		importance: 2,
		type: ["lifestyle"],
		category: "openCommonSpots",
	},
	{ code: "spa", name: "Spa", icon: "amenities/colored/spa", order: 1, importance: 0, type: ["lifestyle"] },
	{
		code: "skatingRing",
		name: "Skating Ring",
		icon: "amenities/colored/skating-ring",
		order: 1,
		importance: 0,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "snookerTable",
		name: "Snooker table",
		icon: "amenities/colored/snooker-table",
		order: 2,
		importance: 1,
		type: ["games"],
		category: "sportsArea",
	},
	{
		code: "solarWaterHeater",
		name: "Solar Water Heater",
		icon: "amenities/colored/solar-water-heater",
		order: 1,
		importance: 1,
		type: ["eco"],
	},
	{
		code: "squashCourt",
		name: "Squash Court",
		icon: "amenities/colored/squash-court",
		order: 0,
		importance: 1,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "swimmingPool",
		name: "Swimming pool",
		icon: "amenities/colored/swimming-pool",
		order: 0,
		importance: 2,
		type: ["sports", "health"],
	},
	{
		code: "tableTennis",
		name: "Table Tennis",
		icon: "amenities/colored/table-tennis",
		order: 3,
		importance: 1,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "tennisCourt",
		name: "Tennis Court",
		icon: "amenities/colored/tennis-court",
		order: 2,
		importance: 1,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "visitorParking",
		name: "Visitor Parking",
		icon: "amenities/colored/visitor-parking",
		order: 7,
		importance: 3,
		type: ["lifestyle"],
	},
	{
		code: "waterTreatmentPlant",
		name: "Water treatment plant",
		icon: "amenities/colored/water-treatment-plant",
		order: 4,
		importance: 1,
		type: ["health"],
	},
	{
		code: "worshipPlace",
		name: "Worship place",
		icon: "amenities/colored/worship-place",
		order: 8,
		importance: 1,
		type: ["lifestyle"],
	},
	{
		code: "yogaMeditationRoom",
		name: "Yoga/Meditation room",
		icon: "amenities/colored/yoga-meditation-room",
		order: 8,
		importance: 2,
		type: ["health"],
	},
	{
		code: "joggingTrack",
		name: "Jogging Track",
		icon: "amenities/colored/jogging-track",
		order: 8,
		importance: 2,
		type: ["health", "sports"],
	},
	{
		code: "cricketNet",
		name: "Cricket Net",
		icon: "amenities/colored/cricket",
		order: 10,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "playGround",
		name: "Play Ground",
		icon: "amenities/colored/football-ground",
		order: 10,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "clubHouse",
		name: "Club house/Party Hall",
		icon: "amenities/colored/club-house",
		order: 9,
		importance: 3,
		type: ["lifestyle"],
		category: "clubHallGym",
	},
	{
		code: "volleyballCourt",
		name: "Volleyball Court",
		icon: "amenities/colored/volleyball-court",
		order: 11,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "footballGround",
		name: "Football Ground",
		icon: "amenities/colored/football-ground",
		order: 12,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "partyHall",
		name: "Party Hall",
		icon: "amenities/colored/party-hall",
		order: 10,
		importance: 3,
		type: ["lifestyle", "entertainment"],
		category: "clubHallGym",
	},
	{
		code: "volleyball",
		name: "Volleyball",
		icon: "amenities/colored/volleyball-court",
		order: 11,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
	{
		code: "cricketGround",
		name: "Cricket Ground",
		icon: "amenities/colored/cricket-hockey-ground",
		order: 13,
		importance: 3,
		type: ["sports", "health"],
		category: "sportsArea",
	},
];

export const amenitiesByCode = new Map(amenitiesInfo.map(a => [a.code, a]));
export const amenitiesByName = new Map(amenitiesInfo.map(a => [a.name, a]));
